<template>
  <mux-player
    v-if="playbackData"
    :playback-id="playbackData.playbackId"
    :playback-token="playbackData.token"
    :thumbnail-token="playbackData.thumbnailToken"
    audio
    class="pt-4"
  />
</template>

<script setup lang="ts">
import type { NodeProps } from './RenderNode.vue';
import { ref, onMounted } from 'vue';
import '@mux/mux-player';
import { computed } from 'vue';
import { getAudioAttrs } from '../extensions/Audio/AudioExtension';
import { useMuxMediaFetcher } from '@api/content.api';
import { useAccountStore } from '@stores/account.store';

// Interfaces
import type { PlaybackData } from '@interfaces/media.interface';

// Composables
const audioContentFetcher = useMuxMediaFetcher();
const accountStore = useAccountStore();

// Refs
const playbackData = ref<PlaybackData>();

// Props
const props = defineProps<NodeProps>();

// Computed
const attrs = computed(() => getAudioAttrs(props.node.attrs));

// Lifecycle hooks
onMounted(async () => {
  await audioContentFetcher.execute(
    { id: attrs.value.contentId, thumbnailTime: 0 },
    accountStore.authToken,
  );
  playbackData.value = audioContentFetcher.data.value;
});
</script>
